
    (function(){
      const root     = document.getElementById('sc-template--19166064476202__highlight_carousel_1_white_bXFFmK');
      if (!root) return;
      const viewport = root.querySelector('.sc-viewport');
      const panelsEl = root.querySelector('.sc-panels');
      const panels   = Array.from(root.querySelectorAll('.sc-panel'));
      const prevBtn  = root.querySelector('.sc-prev');
      const nextBtn  = root.querySelector('.sc-next');
      const autoplayMs = 4000;
      const autoplay   = true;

      let i = 0;
      let timer; const lifecycle = new AbortController(); const listen = (target, event, handler, options = {}) => target.addEventListener(event, handler, { ...options, signal: lifecycle.signal }); const removal = new MutationObserver(() => { if (!root.isConnected) { clearInterval(timer); clearTimeout(root.__rsz); lifecycle.abort(); if (typeof io !== 'undefined') io.disconnect(); removal.disconnect(); } }); removal.observe(document.body, {childList:true,subtree:true});
      let inView = false;

      panelsEl.addEventListener('dragstart', e => e.preventDefault());

      const gap   = () => parseFloat(getComputedStyle(panelsEl).gap || '0') || 0;
      const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
      const cardW = () => isDesktop() ? 457 : viewport.clientWidth;
      const step  = () => cardW() + gap();

      const visibleFull = () => {
        const w = viewport.clientWidth, s = step();
        return Math.max(1, Math.floor((w + gap()) / s));
      };

      const totalW    = () => panels.length * cardW() + Math.max(0, panels.length - 1) * gap();
      const maxScroll = () => Math.max(0, totalW() - viewport.clientWidth);
      const curOffset = () => Math.min(i * step(), maxScroll());
      const setX = () => { panelsEl.style.transform = `translateX(${-curOffset()}px)`; };

      function updateVideos(){
        const start = i, end = i + visibleFull();
        panels.forEach((p, idx) => {
          const active = idx >= start && idx < end && inView;
          p.querySelectorAll('video').forEach(v => {
            try {
              if (active) { v.muted = true; v.play()?.catch(()=>{}); }
              else { v.pause?.(); }
            } catch(e){}
          });
        });
      }

      function markActive(){
        const v = visibleFull();
        panels.forEach((p, idx) => p.classList.toggle('sc-active', idx >= i && idx < i + v));
        updateVideos();
      }

      function updateArrows(){
        if (!prevBtn || !nextBtn) return;
        const atStart = i <= 0;
        const atEnd   = curOffset() >= maxScroll() - 1;
        prevBtn.disabled = atStart; nextBtn.disabled = atEnd;
        prevBtn.classList.toggle('is-dim', atStart);
        nextBtn.classList.toggle('is-dim', atEnd);
      }

      const lastIndex = () => Math.max(0, panels.length - visibleFull());
      function goTo(n){
        if (!panels.length) return;
        i = Math.max(0, Math.min(n, lastIndex()));
        setX(); markActive(); updateArrows();
      }
      const next = ()=> goTo(i + 1);
      const prev = ()=> goTo(i - 1);

      const shouldAutoplay = () => autoplay && !isDesktop() && inView;
      function startAutoplay(){
        clearInterval(timer);
        if (!shouldAutoplay()) return;
        timer = setInterval(()=>{
          if (curOffset() >= maxScroll() - 1){ clearInterval(timer); return; }
          next();
        }, autoplayMs);
      }
      function stopAutoplay(){ clearInterval(timer); }

      function onResize(){
        if (i > lastIndex()) i = lastIndex();
        setX(); markActive(); updateArrows();
        startAutoplay();
      }

      const io = new IntersectionObserver((entries)=>{
        const e = entries[0];
        inView = !!(e && e.isIntersecting && e.intersectionRatio >= 0.6);
        if (inView){ updateVideos(); startAutoplay(); } else { stopAutoplay(); updateVideos(); }
      }, { root: null, threshold: [0, 0.6] });
      io.observe(root);

      document.addEventListener('visibilitychange', ()=>{
        if (document.hidden) { stopAutoplay(); }
        else { updateVideos(); startAutoplay(); }
      });

      listen(window, 'load', onResize);
      listen(window, 'resize', ()=>{ clearTimeout(root.__rsz); root.__rsz = setTimeout(onResize, 100); });
      window.matchMedia('(min-width: 1024px)').addEventListener?.('change', onResize);

      prevBtn && prevBtn.addEventListener('click', ()=>{ prev(); startAutoplay(); });
      nextBtn && nextBtn.addEventListener('click', ()=>{ next(); startAutoplay(); });

      // 拖拽/滑动
      let dragging=false, startX=0, startY=0, startT=0, lock=null, startOffsetX=0;
      function onDown(e){
        if (e.target.closest('.sc-arrows, .sc-btn, a, button, input, textarea, select, label')) return;
        if (e.buttons !== undefined && e.pointerType === 'mouse' && e.buttons !== 1) return;

        dragging=true; lock=null;
        startX=e.clientX; startY=e.clientY; startT=performance.now();
        startOffsetX = -curOffset();
        panelsEl.classList.add('sc-dragging');
        viewport.classList.add('is-dragging');
        stopAutoplay();
        panelsEl.setPointerCapture?.(e.pointerId);
      }
      function onMove(e){
        if (!dragging) return;
        const dx=e.clientX-startX, dy=e.clientY-startY;
        if (lock==null && (Math.abs(dx)>8 || Math.abs(dy)>8)) lock = Math.abs(dx)>=Math.abs(dy)?'x':'y';
        if (lock==='y'){ onUp(e,true); return; }
        if (lock==='x'){
          const minX = -maxScroll(), maxX = 0;
          let x = startOffsetX + dx;
          if (x > maxX) x = maxX;
          if (x < minX) x = minX;
          panelsEl.style.transform = `translateX(${x}px)`;
          e.preventDefault?.();
        }
      }
      function onUp(e, cancel=false){
        if (!dragging) return;
        dragging=false;
        panelsEl.classList.remove('sc-dragging');
        viewport.classList.remove('is-dragging');
        panelsEl.releasePointerCapture?.(e.pointerId);

        if (cancel){ setX(); updateArrows(); updateVideos(); startAutoplay(); return; }

        const dx=e.clientX-startX, dt=Math.max(1, performance.now()-startT), vx=dx/dt;
        const threshold = cardW()*0.25, speed=0.35;
        if (dx<=-threshold || vx<=-speed) next();
        else if (dx>=threshold || vx>=speed) prev();
        else { setX(); updateArrows(); }
        updateVideos();
        startAutoplay();
      }
      panelsEl.addEventListener('pointerdown', onDown, {passive:true});
      listen(window, 'pointermove', onMove, {passive:false});
      listen(window, 'pointerup', onUp, {passive:true});
      listen(window, 'pointercancel', e=>onUp(e,true), {passive:true});
    })();
